import path from '@/api/index'
import { axios } from '@/utils/request'
import parsePageParams from "../../utils/page";


// 分页
export function coursePage(data) {
    return axios({
        url: path.client + '/course/coursePage',
        method: 'POST',
        data: data,
        params: parsePageParams(data)
    })
}

//获取详细信息
export function getUnpaidDetailById (id) {
    return axios({
        url: path.client + '/course/getUnpaidDetailById/id/'+id,
        method: 'GET',
    })
}


//获取详细信息
export function getReturnDetailById (id) {
    return axios({
        url: path.client + '/course/getReturnDetailById/id/'+id,
        method: 'GET',
    })
}



// 支付接口
export function pay(data) {
    return axios({
        url: path.client + '/course/pay',
        method: 'PUT',
        data: data
    })
}
// 退费接口
export function reimburse(data) {
    return axios({
        url: path.client + '/course/reimburse',
        method: 'PUT',
        data: data
    })
}

// 保存
export function save (data) {
    return axios({
        url: path.client + '/course/add',
        method: 'PUT',
        data: data
    })
}
// 消课操作
export function cancelClasses (data) {
    return axios({
        url: path.client + '/course/cancelClasses',
        method: 'PUT',
        data: data
    })
}

// 消课确认
export function confirmClasses (data) {
    return axios({
        url: path.back + '/fundsManagement/curriculumSignDetail/transferCourseWaitConfirm',
        method: 'POST',
        data: data
    })
}